import { Button, Drawer } from 'antd';
import styled from 'styled-components';
import logoSmall from 'assets/logos/logoSmall.svg';

const TOUCH_TARGET = '44px';
const BORDER_COLOR = '#f0f0f0';
const TEXT_COLOR = '#263238';
const MUTED_TEXT_COLOR = '#8c8c8c';
const PRIMARY_COLOR = '#F78E1E';
const PRIMARY_LIGHT_COLOR = '#fff7e6';
const DANGER_COLOR = '#f5222d';

export const MobileMenu = styled(Drawer)`
  .ant-drawer-content-wrapper {
    width: 100% !important;
  }

  .ant-drawer-body {
    display: flex;
    flex-direction: column;
    padding: 0;
  }
`;

export const DrawerHeader = styled.div`
  display: flex;
  flex: none;
  align-items: center;
  justify-content: space-between;
  height: 64px;
  padding: 0 8px 0 16px;
  border-bottom: 1px solid ${BORDER_COLOR};
`;

export const Brand = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  min-width: 0;
`;

export const Logo = styled.span`
  display: block;
  flex: none;
  width: 32px;
  height: 26px;
  background-image: url(${logoSmall});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
`;

export const BrandName = styled.span`
  overflow: hidden;
  font-size: 1rem;
  font-weight: 500;
  color: ${TEXT_COLOR};
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const IconButton = styled.button.attrs({ type: 'button' })`
  display: flex;
  flex: none;
  align-items: center;
  justify-content: center;
  width: ${TOUCH_TARGET};
  height: ${TOUCH_TARGET};
  padding: 0;
  font-size: 20px;
  color: ${TEXT_COLOR};
  cursor: pointer;
  background: none;
  border: none;
`;

export const DrawerBody = styled.div`
  flex: 1;
  padding: 16px 8px;
  overflow-y: auto;
`;

export const WelcomeMessage = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 0 12px 16px;
`;

export const Welcome = styled.span`
  font-size: 0.875rem;
  color: ${MUTED_TEXT_COLOR};
`;

export const UserName = styled.span`
  font-size: 1rem;
  font-weight: bold;
  line-height: 1.25;
  color: ${TEXT_COLOR};
  overflow-wrap: anywhere;
`;

export const SectionTitle = styled.span`
  display: block;
  padding: 8px 12px 4px;
  font-size: 11px;
  font-weight: bold;
  color: ${MUTED_TEXT_COLOR};
  text-transform: uppercase;
  letter-spacing: 0.06em;
`;

export const MenuList = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const MenuItem = styled.button.attrs({ type: 'button' })`
  display: flex;
  gap: 12px;
  align-items: center;
  width: 100%;
  min-height: ${TOUCH_TARGET};
  padding: 0 12px;
  font-size: 1rem;
  color: ${TEXT_COLOR};
  text-align: left;
  cursor: pointer;
  background: transparent;
  border: 0;
  border-radius: 2px;

  &:hover,
  &:focus-visible {
    color: ${PRIMARY_COLOR};
    background-color: ${PRIMARY_LIGHT_COLOR};
    outline: none;
  }
`;

export const ItemIcon = styled.span`
  display: flex;
  flex: none;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  font-size: 18px;

  svg {
    width: 18px;
    height: 18px;
    fill: currentColor;

    path {
      fill: currentColor;
    }
  }
`;

export const ItemLabel = styled.span`
  flex: 1;
  min-width: 0;
`;

export const ExternalIcon = styled(ItemIcon)`
  color: ${MUTED_TEXT_COLOR};

  svg {
    width: 14px;
    height: 14px;
  }
`;

export const Divider = styled.div`
  height: 1px;
  margin: 8px 0;
  background-color: ${BORDER_COLOR};
`;

export const DrawerFooter = styled.div`
  flex: none;
  padding: 16px;
  padding-bottom: calc(16px + env(safe-area-inset-bottom));
  border-top: 1px solid ${BORDER_COLOR};
`;

export const LogoutButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: ${TOUCH_TARGET};
  padding: 0 16px;
  color: white;
  background: ${DANGER_COLOR};
  border-color: ${DANGER_COLOR};
  border-radius: 2px;

  &.ant-btn:focus,
  &.ant-btn:hover,
  &.ant-btn:not(.not-active):active {
    color: white;
    background: ${DANGER_COLOR};
    border-color: ${DANGER_COLOR};
  }
`;
